export const showreelItems = [
  {
    id: 0,
    title: 'KODO — 2026 Showreel - HELLO WORLD',
    category: 'AI Technology',
    client: 'KODO Studio',
    duration: '',
    accentColor: 'blue',
    youtubeId: '8nVny4NvHZU',
    comingSoon: false,
    thumbnail: 'https://readdy.ai/api/search-image?query=ultra%20cinematic%20widescreen%20showreel%20thumbnail%20with%20dramatic%20dark%20background%2C%20abstract%20AI%20neural%20network%20light%20trails%20in%20electric%20blue%20and%20neon%20purple%2C%20futuristic%20digital%20art%2C%20high%20contrast%2C%20no%20people%2C%20no%20text%2C%20pure%20abstract%20cinematic%20visual%2C%20glowing%20particles%20and%20geometric%20shapes%2C%20ultra%20wide%20format&width=1920&height=820&seq=showreel-hero-kodo-v4&orientation=landscape',
  },
  {
    id: 1,
    title: 'Neural Brand Film',
    category: 'AI Films',
    client: 'Apex Technologies',
    duration: '2:30',
    accentColor: 'blue',
    youtubeId: '8DM5q1a-9rY',
    comingSoon: false,
    thumbnail: 'https://readdy.ai/api/search-image?query=cinematic%20dark%20brand%20film%20thumbnail%20with%20electric%20blue%20light%20beams%20and%20abstract%20technology%20visualization%2C%20futuristic%20corporate%20aesthetic%2C%20dramatic%20shadows%2C%20no%20people%2C%20no%20text%2C%20high%20contrast%20dark%20background%20with%20glowing%20neon%20accents&width=800&height=500&seq=showreel-01-kodo&orientation=landscape',
  },
  {
    id: 2,
    title: 'Vertical Series',
    category: 'AI Series',
    client: 'Nexus Media',
    duration: '8:15',
    accentColor: 'purple',
    youtubeId: 'loaefLjj6jQ',
    comingSoon: false,
    thumbnail: 'https://readdy.ai/api/search-image?query=dark%20cinematic%20series%20thumbnail%20with%20neon%20purple%20glow%2C%20abstract%20storytelling%20visual%2C%20moody%20atmospheric%20lighting%2C%20futuristic%20digital%20art%2C%20no%20people%2C%20no%20text%2C%20dramatic%20composition%20with%20deep%20shadows%20and%20purple%20accent%20lighting&width=800&height=500&seq=showreel-02-kodo&orientation=landscape',
  },
  {
    id: 3,
    title: 'AI Training Module',
    category: 'Training',
    client: 'Meridian Corp',
    duration: '1:00',
    accentColor: 'blue',
    youtubeId: 'o_eTSYhclrc',
    comingSoon: false,
    thumbnail: 'https://readdy.ai/api/search-image?query=sleek%20dark%20corporate%20training%20video%20thumbnail%20with%20holographic%20interface%20elements%2C%20electric%20blue%20neon%20glow%2C%20futuristic%20minimalist%20design%2C%20abstract%20data%20visualization%2C%20no%20people%2C%20no%20text%2C%20high-tech%20aesthetic%20with%20glowing%20blue%20accents%20on%20black%20background&width=800&height=500&seq=showreel-03-kodo&orientation=landscape',
  },
  {
    id: 4,
    title: 'Mobile Games — Coming Soon',
    category: 'Games',
    client: 'KODO Interactive',
    duration: '',
    accentColor: 'purple',
    youtubeId: '',
    comingSoon: true,
    thumbnail: 'https://readdy.ai/api/search-image?query=dark%20cinematic%20mobile%20game%20concept%20thumbnail%20with%20dramatic%20purple%20and%20blue%20neon%20lighting%2C%20abstract%20fantasy%20technology%20art%2C%20futuristic%20game%20aesthetic%2C%20no%20people%2C%20no%20text%2C%20high%20contrast%20dark%20background%20with%20glowing%20purple%20and%20electric%20blue%20light%20effects&width=800&height=500&seq=showreel-04-kodo-v5&orientation=landscape',
  },
  {
    id: 5,
    title: 'KODO App — Professional Solutions', // KODO App
    category: 'AI Series',
    client: 'Stratos Media',
    duration: '3:20',
    accentColor: 'blue',
    youtubeId: 'CgiB7Pf_LHY',
    comingSoon: false,
    thumbnail: 'https://readdy.ai/api/search-image?query=elegant%20dark%20cinematic%20series%20thumbnail%20with%20abstract%20storytelling%20visual%2C%20electric%20blue%20and%20white%20accent%20lighting%2C%20luxury%20cinematic%20aesthetic%2C%20dramatic%20composition%2C%20no%20people%2C%20no%20text%2C%20dramatic%20shadows%20with%20glowing%20blue%20data%20streams&width=800&height=500&seq=showreel-05-kodo-v5&orientation=landscape',
  },
];
